import { Skeleton } from "@/shared/ui/kit/skeleton";

export function NotificationCardSkeleton() {
  return (
    <div className="flex gap-3 p-2 rounded-md">
      {/* Icon skeleton */}
      <Skeleton className="shrink-0 size-10 rounded-full" />

      {/* Content skeleton */}
      <div className="flex-1 min-w-0 space-y-2">
        <div className="flex items-center justify-between gap-2">
          <Skeleton className="h-4 w-3/4" />
          <Skeleton className="size-2 rounded-full" />
        </div>
        <Skeleton className="h-3 w-full" />
        <Skeleton className="h-3 w-1/2" />
        <Skeleton className="h-3 w-16" />
      </div>
    </div>
  );
}

export function NotificationListSkeleton({ count = 5 }: { count?: number }) {
  return (
    <div className="p-2 space-y-1">
      {Array.from({ length: count }).map((_, i) => (
        <NotificationCardSkeleton key={i} />
      ))}
    </div>
  );
}
